export default __webpack_public_path__ + "static/media/ic_sign in_16.b6f5b1d9.svg";